import { create } from "zustand"

const reportingStore = (set, get) => ({
  dateRange: { start_date: null, end_date: null },
  setDateRange: (newData) => set({ dateRange: newData }),
  programmations: [],
  setProgrammations: (newData) => set({ programmations: newData }),
  integrations: [],
  setIntegrations: (newData) => set({ integrations: newData }),
  loading: false,
  setLoading: (newData) => set({ loading: newData }),

  globalStats: {},
  setGlobalStats: (newData) => set({ globalStats: newData }),

  globalStatsDate: {},
  setGlobalStatsDate: (newData) => set({ globalStatsDate: newData }),

  actualStats: {},
  setActualStats: (newData) => set({ actualStats: newData }),

  actualStatsDate: [],
  setActualStatsDate: (newData) => set({ actualStatsDate: newData }),
  loadingDate: false,
  setLoadingDate: (newData) => set({ loadingDate: newData }),

  progStats: [],
  setProgStats: (newData) => set({ progStats: newData }),
  loadingProgStats: false,
  setLoadingProgStats: (newData) => set({ loadingProgStats: newData }),
})

export const useReportingStore = create(reportingStore)